var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/combineLatest';
import * as moment from 'moment';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { ApiProvider, EmptySubscriber } from '../api/api';
import { OPS_COMPLETED_ORDER_COLLECTION, OPS_ORDER_COLLECTION, getAll, } from '../../state/state';
import { OpsOrderModel, OrderStatus, } from '../../models/order.ops';
import { CollectionActions } from '../../state/actions';
import { MessageProvider } from '../message/message';
import { FillerShiftModel } from '../../models/filler-shift';
import { NoteModel } from '../../models/note';
import { OpsVehicleModel, } from '../../models/vehicle.ops';
import { SessionProvider } from '../session/session';
import { TruckModel } from '../../models/truck';
import { UserModel } from '../../models/user';
import { UserProvider } from '../user/user';
let OpsProvider = OpsProvider_1 = class OpsProvider {
    constructor(store, collectionActions, userProvider, session, api, msgService) {
        this.store = store;
        this.collectionActions = collectionActions;
        this.userProvider = userProvider;
        this.session = session;
        this.api = api;
        this.msgService = msgService;
        this.selectedTruck$ = new BehaviorSubject(null);
        this.selectedFleetAccount$ = new BehaviorSubject(null);
        // Messages
        this._sentMessages = {};
        this.getCurrentFillerShift();
        this.openOrders$ = store.select(state => getAll(state.opsOrders));
        this.openOrderCount$ = store.select(state => state.opsOrders.total_result);
        this.completedOrders$ = store.select(state => getAll(state.opsCompletedOrders));
        this.completedOrderCount$ = store.select(state => state.opsCompletedOrders.total_result);
        this.confirmedOrders$ = store.select(state => this.confirmedOrders(getAll(state.opsOrders)));
        this.loadingOpenOrders$ = store.select(state => state.opsOrders.loading);
        this.loadingCompletedOrders$ = store.select(state => state.opsCompletedOrders.loading);
        this.completedOnTimePercentage$ = store.select(state => this.computeOnTimePercentage(getAll(state.opsCompletedOrders)));
        this.completedOrdersThisShift$ = store.select(state => this.ordersCompletedThisShift(getAll(state.opsCompletedOrders)));
    }
    // Shift
    getCurrentFillerShift() {
        this.userProvider.getCurrentFillerShift();
        this.userProvider.currentFillerShift$.subscribe((shift) => {
            this.currentFillerShift = shift;
            this.currentFillerShift &&
                this.selectedTruck$.next(this.currentFillerShift.truck);
        });
    }
    startShift(truck) {
        if (truck) {
            let request = this.api
                .call({
                url: `/trucks/${truck.uid}/filler_shifts`,
                method: 'POST',
                ops: true,
            })
                .map(result => new FillerShiftModel(result));
            request
                .do(() => {
                this.userProvider.getUser();
            })
                .subscribe(new EmptySubscriber());
            return request;
        }
        return Observable.throw('no truckId present');
    }
    endShift(shift) {
        let request = new Observable();
        if (shift && shift.uid && shift.truck && shift.truck.uid) {
            request = this.api.call({
                url: `/trucks/${shift.truck.uid}/filler_shifts/${shift.uid}`,
                method: 'PATCH',
                ops: true,
            });
            request
                .do(() => {
                this.setSelectedTruck(null);
                this.userProvider.getUser();
            })
                .subscribe(new EmptySubscriber());
        }
        return request;
    }
    // Orders
    getOrdersForTruck(truck, pageNumber, preventUpdatingStore) {
        this.store.dispatch(this.collectionActions.setLoading(OPS_ORDER_COLLECTION, true));
        let options = {
            url: `/fillers/trucks/${truck.uid}/schedule`,
            method: 'GET',
            includePageInfo: true,
            ops: true,
        };
        if (pageNumber || pageNumber === 0) {
            options.params = { page: pageNumber };
        }
        if (pageNumber === 1 && preventUpdatingStore) {
            options.compareEtag = true;
        }
        let request = this.api
            .call(options)
            .map(result => {
            return {
                items: result.response.map(item => new OpsOrderModel(item)),
                pageInfo: result.pageInfo,
                status: result.status,
            };
        })
            .finally(() => this.store.dispatch(this.collectionActions.setLoading(OPS_ORDER_COLLECTION, false)));
        request
            .do(pagedItems => {
            if (!preventUpdatingStore) {
                pagedItems.items = this.sortClaimedOrders(pagedItems.items);
                if (pageNumber > 1) {
                    this.store.dispatch(this.collectionActions.append(OPS_ORDER_COLLECTION, pagedItems.items));
                }
                else {
                    this.store.dispatch(this.collectionActions.setWithPageInfo(OPS_ORDER_COLLECTION, pagedItems));
                }
            }
        })
            .subscribe(new EmptySubscriber());
        return request;
    }
    createMeetingURL(uid) {
        return this.api
            .call({
            url: `/fillers/orders/${uid}/meetings`,
            method: 'POST',
            ops: true,
        })
            .flatMap(() => {
            return this.getOrder(uid);
        });
    }
    getOrder(uid) {
        let request = this.api
            .call({
            url: `/fillers/orders/${uid}`,
            method: 'GET',
            ops: true,
        })
            .map(item => new OpsOrderModel(item));
        request
            .do(order => {
            this.store.dispatch(this.collectionActions.update(OPS_ORDER_COLLECTION, order));
            this.store.dispatch(this.collectionActions.update(OPS_COMPLETED_ORDER_COLLECTION, order));
        })
            .subscribe(new EmptySubscriber());
        return request;
    }
    // Subscribes to updates to any particular order in the application store
    subscribeToOrder(uid) {
        let updatedOpenOrders$ = this.store.select(state => getAll(state.opsOrders));
        let updatedCompletedOrders$ = this.store.select(state => getAll(state.opsCompletedOrders));
        return updatedOpenOrders$
            .merge(updatedCompletedOrders$)
            .map((orders) => {
            return orders.filter((order) => {
                return order.uid == uid;
            })[0];
        })
            .distinct();
    }
    createCancelledOrder(params) {
        return this.api
            .call({
            url: `/fillers/orders/`,
            method: 'POST',
            ops: true,
            params: params,
        })
            .map(data => new OpsOrderModel(data));
    }
    createAndCompleteOrder(params) {
        let request = this.api
            .call({
            url: `/fillers/orders/create_and_complete`,
            method: 'POST',
            ops: true,
            params: params,
        })
            .map(data => new OpsOrderModel(data));
        request
            .do(order => {
            this.store.dispatch(this.collectionActions.insert(OPS_COMPLETED_ORDER_COLLECTION, order));
        })
            .subscribe(new EmptySubscriber());
        return request;
    }
    getCompletedOrders(pageNumber) {
        this.store.dispatch(this.collectionActions.setLoading(OPS_COMPLETED_ORDER_COLLECTION, true));
        let options = {
            url: `/fillers/orders/completed`,
            method: 'GET',
            includePageInfo: true,
            ops: true,
        };
        if (pageNumber) {
            options.params = { page: pageNumber };
        }
        let request = this.api
            .call(options)
            .map(result => {
            return {
                items: result.response.map(item => new OpsOrderModel(item)),
                pageInfo: result.pageInfo,
            };
        })
            .finally(() => this.store.dispatch(this.collectionActions.setLoading(OPS_COMPLETED_ORDER_COLLECTION, false)));
        request
            .do(pagedItems => {
            if (pageNumber > 1) {
                this.store.dispatch(this.collectionActions.append(OPS_COMPLETED_ORDER_COLLECTION, pagedItems.items));
            }
            else {
                this.store.dispatch(this.collectionActions.setWithPageInfo(OPS_COMPLETED_ORDER_COLLECTION, pagedItems));
            }
        })
            .subscribe(new EmptySubscriber());
        return request;
    }
    completeOrder(order, params) {
        let request = this.api
            .call({
            url: `/fillers/orders/${order.uid}/complete`,
            method: 'POST',
            ops: true,
            params: params,
        })
            .flatMap(() => {
            return this.getOrder(order.uid);
        });
        request
            .do(order => {
            this.store.dispatch(this.collectionActions.insert(OPS_COMPLETED_ORDER_COLLECTION, order));
            this.store.dispatch(this.collectionActions.delete(OPS_ORDER_COLLECTION, order));
        })
            .subscribe(new EmptySubscriber());
        return request;
    }
    cancelOrder(order, reason) {
        let request = this.api
            .call({
            url: `/fillers/orders/${order.uid}/cancel`,
            method: 'POST',
            ops: true,
            params: { cancellation_reason: reason },
        })
            .flatMap(() => {
            return this.getOrder(order.uid);
        });
        request
            .do(order => {
            this.store.dispatch(this.collectionActions.delete(OPS_COMPLETED_ORDER_COLLECTION, order));
            this.store.dispatch(this.collectionActions.delete(OPS_ORDER_COLLECTION, order));
        })
            .subscribe(new EmptySubscriber());
        return request;
    }
    deleteOrder(order) {
        let request = this.api
            .call({
            url: `/fillers/orders/${order.uid}`,
            method: 'DELETE',
            ops: true,
        })
            .map(data => new OpsOrderModel(data));
        request
            .do(order => {
            this.store.dispatch(this.collectionActions.delete(OPS_COMPLETED_ORDER_COLLECTION, order));
            this.store.dispatch(this.collectionActions.delete(OPS_ORDER_COLLECTION, order));
        })
            .subscribe(new EmptySubscriber());
        return request;
    }
    startDrivingToOrder(order) {
        let request = this.api
            .call({
            url: `/fillers/orders/${order.uid}/start_driving`,
            method: 'POST',
            ops: true,
        })
            .flatMap(() => this.getOrder(order.uid));
        return request;
    }
    startDrivingToOrders(orders) {
        let requests = [];
        for (let order of orders) {
            let request = this.api
                .call({
                url: `/fillers/orders/${order.uid}/start_driving`,
                method: 'POST',
                ops: true,
            })
                .flatMap(() => this.getOrder(order.uid));
            requests.push(request);
        }
        return Observable.combineLatest(requests);
    }
    sendETAForOrder(order) {
        return Observable.fromPromise(this.getCurrentPosition())
            .flatMap(position => this.getEstimatedTimeToOrder(position, order))
            .flatMap(time => this.saveEtaForOrder(order, time))
            .flatMap(() => this.getOrder(order.uid));
    }
    sendETAToOrders(orders) {
        return Observable.fromPromise(this.getCurrentPosition())
            .flatMap(position => this.getEstimatedTimeToOrder(position, orders[0]))
            .flatMap(time => this.saveEtaForOrders(orders, time));
    }
    clearETAForOrder(order) {
        let request = this.api
            .call({
            url: `/fillers/orders/${order.uid}/order_eta`,
            method: 'DELETE',
            ops: true,
        })
            .flatMap(() => {
            return this.getOrder(order.uid);
        });
        return request;
    }
    getEstimatedTimeToOrder(currentPosition, order) {
        let params = {
            origin: new google.maps.LatLng(currentPosition.latitude, currentPosition.longitude),
            destination: new google.maps.LatLng(order.lat, order.lng),
            travelMode: google.maps.TravelMode.DRIVING,
            provideRouteAlternatives: false,
            avoidHighways: false,
        };
        return Observable.create(observer => {
            let directionsService = new google.maps.DirectionsService();
            directionsService.route(params, (result, status) => {
                if (status == google.maps.DirectionsStatus.OK) {
                    let ms = result.routes[0].legs[0].duration.value * 1000;
                    let time = new Date(new Date().getTime() + ms);
                    observer.next(time);
                    observer.complete();
                }
                else {
                    observer.error(new Error('Error getting eta'));
                }
            });
        });
    }
    saveEtaForOrder(order, time) {
        return this.api.call({
            url: '/order_etas',
            method: 'POST',
            ops: true,
            convertToParams: true,
            body: {
                eta: moment(time).format('HH:mm'),
                order_uids: [order.uid],
            },
        });
    }
    saveEtaForOrders(orders, time) {
        return this.api.call({
            url: '/order_etas',
            method: 'POST',
            ops: true,
            convertToParams: true,
            body: {
                eta: moment(time).format('HH:mm'),
                order_uids: orders.map(order => order.uid),
            },
        });
    }
    getCurrentPosition() {
        if (typeof navigator === 'undefined' ||
            !navigator.geolocation ||
            !navigator.geolocation.getCurrentPosition) {
            return Promise.reject('Geolocation is not supported by this browser.');
        }
        return new Promise((resolve, reject) => {
            navigator.geolocation.getCurrentPosition(position => resolve({
                latitude: position.coords.latitude,
                longitude: position.coords.longitude,
                heading: position.coords.heading,
            }), () => reject('Unable to determine your current location.'), {
                enableHighAccuracy: true,
                maximumAge: 0,
                timeout: 10000,
            });
        });
    }
    // Notes
    getCustomerNotes(uid) {
        let request = this.api
            .call({
            url: `/users/${uid}/notes`,
            params: {
                notated_object: 'User',
                uid: uid,
            },
            method: 'GET',
        })
            .map(res => res.map(note => new NoteModel(note)));
        request.subscribe(new EmptySubscriber());
        return request;
    }
    addNoteForCustomer(uid, params) {
        return this.api
            .call({
            url: `/users/${uid}/notes?uid=${uid}`,
            method: 'POST',
            params: params,
        })
            .map(data => new NoteModel(data));
    }
    sendMessageForOrder(order, fillerMessageType) {
        return this.msgService.sendMessageToCustomer(order, fillerMessageType, this._sentMessages);
    }
    didSendMessageForOrder(order, fillerMessageType) {
        let key = fillerMessageType + order.uid;
        return this._sentMessages[key] == true;
    }
    // Vehicles
    vehicleLookup(user, type, query) {
        let params = {};
        params[type] = query;
        params.account_uid = user.uid;
        return this.api
            .call({
            url: `/fillers/vehicles/lookup`,
            method: 'GET',
            ops: true,
            params: params,
        })
            .map(result => result.map(item => new OpsVehicleModel(item)));
    }
    updateVehicleForOrder(order, params) {
        let request = this.api
            .call({
            url: `/fillers/vehicles/${order.vehicle.uid}`,
            method: 'PATCH',
            ops: true,
            params: params,
        })
            .flatMap(() => {
            return this.getOrder(order.uid);
        });
        return request;
    }
    saveMiles(vehicle, mileage) {
        return this.api.call({
            url: `/vehicles/${vehicle.uid}/mileages`,
            method: 'POST',
            params: {
                mileage,
            },
            ops: true,
        });
    }
    // Trucks
    getTrucks(pageNumber = 1, paginate = true) {
        const options = {
            url: `/fillers/trucks`,
            method: 'GET',
            params: {},
            ops: true,
        };
        if (paginate) {
            options.params['page'] = pageNumber;
        }
        let request = this.api.call(options).map(result => {
            return result.map(item => new TruckModel(item));
        });
        return request;
    }
    getTruck(uid) {
        return this.api
            .call({
            url: `/fillers/trucks/${uid}`,
            method: 'GET',
            ops: true,
        })
            .map(result => new TruckModel(result));
    }
    setSelectedTruck(truck) {
        let payload = truck ? truck.json : null;
        this.session.set(OpsProvider_1.SELECTED_TRUCK_KEY, payload);
        this.selectedTruck$.next(truck);
        this.getOrdersForTruck(truck, 1);
    }
    loadSelectedTruck() {
        return this.session.get(OpsProvider_1.SELECTED_TRUCK_KEY).then(data => {
            if (this.currentFillerShift) {
                this.selectedTruck$.next(this.currentFillerShift.truck);
            }
            else if (data) {
                let truck = new TruckModel(data);
                this.selectedTruck$.next(truck);
                this.getTruck(truck.uid).subscribe(truck => {
                    this.session.set(OpsProvider_1.SELECTED_TRUCK_KEY, truck);
                    this.selectedTruck$.next(truck);
                });
            }
            else {
                this.selectedTruck$.next(null);
            }
        });
    }
    // Fleets
    loadSelectedFleetAccount() {
        this.session.get(OpsProvider_1.SELECTED_ACCOUNT_KEY).then(data => {
            if (data) {
                let account = new UserModel(data);
                this.selectedFleetAccount$.next(account);
            }
            else {
                this.selectedFleetAccount$.next(null);
            }
        });
    }
    setSelectedFleetAccount(account) {
        let payload = account ? account.json : null;
        this.session.set(OpsProvider_1.SELECTED_ACCOUNT_KEY, payload);
        this.selectedFleetAccount$.next(account);
    }
    getFleetAccounts() {
        return this.api
            .call({
            url: `/fillers/accounts/fleet`,
            method: 'GET',
            ops: true,
        })
            .map(result => result.map(item => new UserModel(item)));
    }
    // Helpers
    confirmedOrders(orders) {
        return orders.filter(order => order.deliveryLocation);
    }
    sortClaimedOrders(orders) {
        const claimedOrders = [];
        const otherOrders = [];
        orders.forEach(order => order.status === OrderStatus.Claimed
            ? claimedOrders.push(order)
            : otherOrders.push(order));
        return claimedOrders.concat(otherOrders);
    }
    computeOnTimePercentage(completedOrders) {
        if (!completedOrders.length || !this.currentFillerShift) {
            return null;
        }
        const completedThisShift = this.ordersCompletedThisShift(completedOrders);
        const completedOnTime = completedThisShift.filter(order => order.completedOnTime);
        return completedThisShift
            ? (completedOnTime.length / completedThisShift.length) * 100
            : 0;
    }
    ordersCompletedThisShift(orders) {
        if (!orders || !this.currentFillerShift) {
            return [];
        }
        return orders.filter(order => {
            return (order.timeCompleted &&
                moment(order.timeCompleted).isAfter(this.currentFillerShift.clockIn));
        });
    }
};
OpsProvider.SELECTED_TRUCK_KEY = 'selectedTruck';
OpsProvider.SELECTED_ACCOUNT_KEY = 'selectedFleetAccount';
OpsProvider = OpsProvider_1 = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [Store,
        CollectionActions,
        UserProvider,
        SessionProvider,
        ApiProvider,
        MessageProvider])
], OpsProvider);
export { OpsProvider };
var OpsProvider_1;
//# sourceMappingURL=ops.js.map


// WEBPACK FOOTER //
// ./src/providers/ops/ops.ts.pre-build-optimizer.js